module.exports = __webpack_public_path__ + "static/media/biology.86859b75.png";